export const lang_path = {
  en: 'en',
  de: 'de',
  es: 'es-es',
};
